import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import "@/components/bid/Bid.css";
import { useNavigate } from "react-router";
import { FaCheckCircle, FaArrowRight } from "react-icons/fa"; // Import specific icons
import { useEffect, useRef } from "react";
import { MdClose } from "react-icons/md";
import { FaRegCircleCheck } from "react-icons/fa6";
import { getPropertyURL } from "@/utils/propertyNavigation";


function SuccessEditCif({commonAttributes, propertyId}) {
  const navigate = useNavigate();
  const successCardRef = useRef(null); // Create a ref for the success card

  const handleNavigatetoPDP = () => {
    navigate(getPropertyURL(`/property/${propertyId}`, commonAttributes?.propCategory, commonAttributes?.status));
  };

  return (
    <Card
      className="text-center container shadow mb-5 bg-white "
      ref={successCardRef}
    >
         {/* <button
         
          onClick={handleNavigatetoPDP}
        >
       
        </button> */}
                {/* <button className="close" 
                variant="secondary" 
                onClick={handleNavigatetoPDP}>

                    <MdClose size={30} color="#00000"/>

                </button> */}

                   <div className="row update-license-actions">
                                            <div className="col-11">

                                            </div>
                                            <div className="col-1 pl50">
                                                
                                                <Button 
                                                    onClick={() => handleNavigatetoPDP()}
                                                    variant="outlined"
                                                >
                                                    <MdClose size={40} color="grey" />
                                                </Button>
                                            </div>
                                        </div>


      <Card.Body className="pb100 pt100">
        <div className="hubzu-bid-success-icon pb0">
          <FaRegCircleCheck  size={50} color="#1cbf21"/>
        </div>
        <Card.Title className="success_msg pt0">Success!</Card.Title>
        <Card.Text className="hubzu-bid-success-submessage pt0">
         Information updated successfully. This information will be used for contract documentation.
        </Card.Text>

       
      </Card.Body>
    </Card>
  );
}

export default SuccessEditCif;
